export const name = 'multilingualService' as const
